import React, { Fragment } from 'react';

const InsuranceConverageSF = ({ city = 'toronto' }) => (
  <Fragment>
    <ol>
      <li>
        <strong>Online insurance</strong>
        <ul>
          <li>
            Covers you while you are online on a rideshare driver
            application app.
            <li>
              Covered by the rideshare company's insurance policy (i.e
              Uber)
            </li>
            <li>
              Pink insurance slip can be found within the rideshare driver
              application (i.e Uber Driver app).{' '}
            </li>
            <li>Maintains a $2,500 insurance deductible</li>
          </li>
        </ul>
      </li>
      <li>
        <strong>Offline insurance</strong>{' '}
        <ul>
          <li>
            Covers you when you are offline on a rideshare driver app, such
            as taking breaks, recharging at Supercharger stations, and
            driving in and out of the Autzu parking lot.
            <li>Covered by Autzu’s insurance policy</li>
            <li>
              Pink insurance slip can be found inside the Autzu app during
              a reservation. From your dashboard, scroll to the quick links
              and choose "Insurance slip" to access the insurance section.
              Click on "No, I was offline" to obtain Autzu's insurance
              details.
            </li>
            <li>Maintains a $2,500 deductible.</li>
          </li>
        </ul>
      </li>
    </ol>
    <p>
      If you are deemed not-at-fault, you will not have to pay any
      insurance deductible.
    </p>
  </Fragment>
);

export default InsuranceConverageSF;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/AccidentsAndInsurance/IndranceCoverageSF.js